import * as Folders from './folders';
import * as Labels from './labels';
import Config from './folders-and-labels.router';
import options from './folders-and-labels.component';

const Component = {
    selector: 'dtFoldersAndLabels',
    options
};

export {
    Folders,
    Labels,
    Config,
    Component
};



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/index.js